import { useState } from 'react';

import useCountry from 'hooks/useCountry';

import Grid from '@material-ui/core/Grid';
import Modal from 'components/CncUI/Modal';
import Table from 'components/CncUI/Table';
import Button from 'components/CncUI/Button';
import Checkbox from 'components/CncUI/Checkbox';
import Priority from './Priority';

import EnumHelper from 'utilities/enumHelper';

const ConfirmModal = props => {
  const { country } = useCountry();
  const isCanada = country === 'CAN';
  const { form, confirm, setConfirm, save, mappings } = props;
  const { amountType, paperless, split, removeRestriction } = props;
  const { isCurrencyEnabled } = props;
  const [saving, setSaving] = useState(false);
  const primary = (form || []).find(a => a.primary);
  const additional = (form || []).filter(a => !a.primary);
  const key = prop => `ConfirmDialog-directDeposit-${prop}`;
  const header = (
    <Table.Head>
      <Table.Row>
        {[
          split ? 'Priority' : null,
          'Bank Name',
          'Account Type',
          'Routing Number',
          'Account Number',
          split ? 'Split Amount' : 'Amount',
        ]
          .filter(Boolean)
          .map(name => (
            <Table.Cell key={key(`-table-header-${name}`)}>{name}</Table.Cell>
          ))}
      </Table.Row>
    </Table.Head>
  );

  return (
    <Modal
      id="DirectDeposit-ConfirmModal"
      disableBackdropClick={saving}
      disableEscapeKeyDown={saving}
      open={confirm}
      onClose={() => setConfirm(false)}
      maxWidth={798}
    >
      <Modal.Title>Review Your Direct Deposit Info</Modal.Title>
      <Modal.Content>
        <Modal.ContentText>
          {`The balance of your ${
            isCanada ? `paycheque` : `paycheck`
          } will be deposited into
              the account(s) below. Direct deposit can take up to 14
              calendar days from election before taking effect. Paper ${
                isCanada ? `cheques` : `checks`
              } will be issued when direct deposit is not available.`}
          {removeRestriction && (
            <>
              <br />
              <br />
              This update will apply to both Cast & Crew and CAPS employee
              records when applicable.
            </>
          )}
        </Modal.ContentText>
        <Grid container spacing={2}>
          <Grid item xs={12}></Grid>
          <Grid item xs={12} style={{ overflowX: 'auto' }}>
            <Table dark size="short">
              {header}
              <Table.Body>
                {additional &&
                  additional.length > 0 &&
                  additional.map((item, index) => (
                    <Table.Row key={key(`additional-row-${index}`)}>
                      <Table.Cell align="center">
                        <Priority short>{index + 1}</Priority>
                      </Table.Cell>
                      <Table.Cell>{item.bankName || ''}</Table.Cell>
                      <Table.Cell>
                        {EnumHelper.valueToOptionLabel(
                          mappings.bankAccountTypes,
                          item.bankAccountType,
                        ).replace(' Account', '')}
                      </Table.Cell>
                      <Table.Cell>{item.routingNumber}</Table.Cell>
                      <Table.Cell>{item.bankAccountNumber}</Table.Cell>
                      {isCurrencyEnabled && (
                        <Table.Cell>
                          {amountType === '$'
                            ? `${parseFloat(item.flatAmount).toFixed(2)} ${
                                item.currencyType === 'CAN' ? 'CAD' : 'USD'
                              }`
                            : `${parseInt(item.splitPercentage, 10)}%`}
                        </Table.Cell>
                      )}
                      {!isCurrencyEnabled && (
                        <Table.Cell>
                          {amountType === '$'
                            ? `$${parseFloat(item.flatAmount).toFixed(2)}`
                            : `${parseInt(item.splitPercentage, 10)}%`}
                        </Table.Cell>
                      )}
                    </Table.Row>
                  ))}
                <Table.Row>
                  {split && (
                    <Table.Cell align="center">
                      <Priority short>{additional.length + 1}</Priority>
                    </Table.Cell>
                  )}
                  <Table.Cell>{primary.bankName || ''}</Table.Cell>
                  <Table.Cell>
                    {EnumHelper.valueToOptionLabel(
                      mappings.bankAccountTypes,
                      primary.bankAccountType,
                    ).replace(' Account', '')}
                  </Table.Cell>
                  <Table.Cell>{primary.routingNumber}</Table.Cell>
                  <Table.Cell>{primary.bankAccountNumber}</Table.Cell>
                  <Table.Cell>
                    {split && additional.length ? 'Remainder' : 'Full Amount'}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Grid>
          <Grid item xs={12} style={{ paddingLeft: 24 }}>
            {!isCanada && (
              <Checkbox disabled checked={paperless} value="checkedD">
                Go paperless to view your pay stubs online.
              </Checkbox>
            )}
          </Grid>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <Button
              secondary
              disabled={saving}
              onClick={() => setConfirm(false)}
            >
              Back to edit
            </Button>
          </Grid>
        </Grid>
        <Grid item>
          <Button
            loading={saving}
            onClick={() => {
              setSaving(true);
              save();
            }}
          >
            Save
          </Button>
        </Grid>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmModal;
